module.exports = __webpack_public_path__ + "img/fold-active.e8de3d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fold-active.png
// module id = yNuT
// module chunks = 4